import { useState } from 'react';
import { useForm } from 'react-hook-form'
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import API_BASE_URL from '../../config';

interface IFormInput {
  email: string;
}

const ForgotPassword = () => {
  const { register, handleSubmit, formState: { errors } } = useForm<IFormInput>()
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const redirectPath = location.state?.path || '/home';
  
  const onSubmit = handleSubmit((values) => {
    const email = values.email;

    const configuration = {
    url: API_BASE_URL + '/forgot-password',
    method: 'post',
    data: {
      email
    },
    }

    axios.request(configuration)
      .then((result) => {

        if (!result.data.token) {
          setErrorMessage("Resultado");
        }
       navigate(redirectPath, { replace: true });
      }).catch(err => {
        console.error("Error en la solicitud:", err);

      if (err.response && err.response.data && err.response.data.message) {
        setErrorMessage(`Error: ${err.response.data.message}`);
      } else {
        setErrorMessage(t('password.error'));
      }
    })
  })

  return (
    <div className='flex min-h-full flex-col justify-center px-6 py-1 lg:px-8'>
      <div className='sm:mx-auto sm:w-full sm:max-w-sm'>
        <h2 className='mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900'>{t('password.recover_password')}</h2>
        <p>{t('password.recover_password_process')}</p>
      </div>
      <div className='mt-10 sm:mx-auto sm:w-full sm:max-w-sm'>
        {errorMessage && <p className='peer-invalid:visible text-red-700 font-light'>{errorMessage}</p>}
        <form onSubmit={onSubmit} className='space-y-6'>
          <div>
            <div className='flex items-center justify-between'>
              <label htmlFor='email' className='text-sm font-medium leading-6 text-gray-900'>{t('profile.email')}</label>
            </div>
            <div className='mt-2'>
              <input
                {...register('email', {
                  required: 'La contraseña es obligatoria'
                })}
                aria-invalid={errors.email ? 'true' : 'false'}
                type='string'
                className='block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6'
              />
            </div>
          </div>
          <div>
            <button
              type='submit'
              className='flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
            >{t('password.recover_password')}</button>
          </div>

        </form>
        </div>
    </div>
  )
}

export default ForgotPassword
